import { useContext } from 'react';
import NextTreeContext from './NextTreeContext';
const useNextTreeStore = () => useContext(NextTreeContext);
export default useNextTreeStore;
